import TypesenseError from "./TypesenseError";

export default class MissingConfigurationError extends TypesenseError {}
